import { forwardRef } from 'react';
import { TextField } from '@mui/material';

const phoneInput = ({ error, helperText, ...props }, ref) => (
  <TextField
    label="Phone Number"
    {...props}
    inputRef={ref}
    fullWidth
    size="small"
    variant="outlined"
    error={!!error}
    helperText={helperText}
  />
);

export default forwardRef(phoneInput);
